/*
 * Plugin que instala validadores customizados baseado no vee-validate.
 */

import {Validator} from 'vee-validate';
import {cpf, cnpj, cpfCnpj} from './cpfCnpj';
import {card, brand} from './card';
import valorRecarga from './valor-recarga-valido';
import valorRecargaOpen from './valor-recarga-valido-open';
import phone from './phone';
import cell from './cell';
import generalMask from './generalMask';
import {plateExist, plateValid} from './plate';
import {accountExists, completeName, older, cep, moveMaisCPF} from './account';
import {beforeOneYear} from './date';
import moment from 'moment';
import recargaMinima from './recarga-minima';
import googleAutocomplete from './google-autocomplete';
import isMultiple from './is-multiple';


const dictionary = {
  'pt-BR': {
    messages: {
      required: () => 'Campo é obrigatório.',
      min: (field, arg) => `Mínimo ${arg} caracteres.`,
      max: (field, arg) => `Máximo ${arg} caracteres.`,
      after: (field) => `Campo deve ser após ${field}`,
      confirmed: (field) => `Campos não conferem`,
      email: (field) => 'O formato do e-mail é inválido.',
      decimal: (field) => 'Campo deve ser numérico',
      numeric: (field) => 'Campo deve ser numérico',
      moveMaisCPF: (field) => 'Senha inválida',
    }
  }
};

const plugin = {};

plugin.install = function (Vue, options) {
  Validator.installDateTimeValidators(moment);
  Validator.updateDictionary(dictionary);
  Validator.setLocale('pt-BR');
  Validator.extend('cpf', cpf);
  Validator.extend('cnpj', cnpj);
  Validator.extend('cpfCnpj', cpfCnpj);
  Validator.extend('valorRecarga', valorRecarga);
  Validator.extend('valorRecargaOpen', valorRecargaOpen);
  Validator.extend('phone', phone);
  Validator.extend('cell', cell);
  Validator.extend('generalMask', generalMask);
  Validator.extend('plateExist', plateExist);
  Validator.extend('plateValid', plateValid);
  Validator.extend('accountExists', accountExists);
  Validator.extend('card', card);
  Validator.extend('complete-name', completeName);
  Validator.extend('older', older);
  Validator.extend('beforeOneYear', beforeOneYear);
  Validator.extend('cep', cep);
  Validator.extend('brand', brand);
  Validator.extend('recargaMinima', recargaMinima);
  Validator.extend('isMultiple', isMultiple);
  Validator.extend('googleAutocomplete', googleAutocomplete);
  Validator.extend('moveMaisCPF', moveMaisCPF);
};

export default plugin;



// WEBPACK FOOTER //
// ./src/validators/index.js